import React, { useMemo } from 'react';
import { useAuth } from '../auth/AuthorizerContext';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  MenuDropdownAuthItems,
  MenuDropdownModals,
  useMenuDropdown,
} from './MenuDropdown';
import { MenuInteractor } from './MenuInteractor';

export const UserMenu: React.FC = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const menuInteractor = useMemo(() => new MenuInteractor(), []);
  const authState = menuInteractor.getAuthMenuState(user);
  const {
    closeCreateTreeModal,
    closeLoginModal,
    handleSignOut,
    isOpen,
    menuPanelProps,
    menuRef,
    menuTriggerProps,
    openCreateTreeModal,
    openLoginModal,
    goToMyTrees,
    showCreateTreeModal,
    showLoginModal,
    toggleMenu,
    triggerRef,
  } = useMenuDropdown({
    navigate,
    pathname: location.pathname,
    signOut,
  });

  return (
    <div className="user-menu" ref={menuRef}>
      <button
        type="button"
        ref={triggerRef}
        className="user-menu-trigger"
        onClick={toggleMenu}
        aria-label="User menu"
        {...menuTriggerProps}
      >
        <img 
          src="/icons/user-menu.png" 
          alt="User menu" 
          className="user-menu-icon"
        />
      </button>
      
      {isOpen && (
        <div className="user-menu-dropdown" {...menuPanelProps}>
          <MenuDropdownAuthItems
            authState={authState}
            header={authState.showHeader ? (
              <div className="user-menu-header" role="none">
                <span className="user-email">{authState.email}</span>
              </div>
            ) : undefined}
            dividerClassName="user-menu-divider"
            itemClassName="user-menu-item"
            onCreateTree={openCreateTreeModal}
            onMyTrees={goToMyTrees}
            onSignIn={openLoginModal}
            onSignOut={handleSignOut}
          />
        </div>
      )}
      
      <MenuDropdownModals
        showCreateTreeModal={showCreateTreeModal}
        showLoginModal={showLoginModal}
        onCloseCreateTreeModal={closeCreateTreeModal}
        onCloseLoginModal={closeLoginModal}
      />
    </div>
  );
};
